import { useState } from 'react';
import { Form, Input, Button, Switch, message, Descriptions, Tag, Divider } from 'antd';
import { api } from '../api';

export default function DelivererForm({ deliverer, onSaved }) {
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  const isStoreLinked = Boolean(deliverer.store_id);

  const handleSave = async (values) => {
    setSaving(true);
    try {
      await api.deliverers.update(deliverer.id, {
        ...values,
        opening_hours_id: deliverer.opening_hours_id ?? null,
      });
      message.success('Lieferant gespeichert');
      onSaved?.();
    } catch (err) {
      message.error(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      {isStoreLinked && (
        <>
          <Tag color="blue" style={{ marginBottom: 12 }}>
            Verknüpft mit Store: {deliverer.store_name}
          </Tag>
          {deliverer.address && (
            <Descriptions column={1} size="small" bordered style={{ marginBottom: 8 }}>
              <Descriptions.Item label="Adresse">
                {deliverer.address.street} {deliverer.address.nr}, {deliverer.address.postalCode} {deliverer.address.city}
              </Descriptions.Item>
            </Descriptions>
          )}
          {deliverer.contact && (
            <Descriptions column={1} size="small" bordered style={{ marginBottom: 16 }}>
              {deliverer.contact.company && (
                <Descriptions.Item label="Firma">{deliverer.contact.company}</Descriptions.Item>
              )}
              {deliverer.contact.phone && (
                <Descriptions.Item label="Telefon">{deliverer.contact.phone}</Descriptions.Item>
              )}
              {deliverer.contact.email && (
                <Descriptions.Item label="E-Mail">{deliverer.contact.email}</Descriptions.Item>
              )}
            </Descriptions>
          )}
          <Divider style={{ fontSize: 12, color: '#999' }}>Lieferant-Einstellungen</Divider>
        </>
      )}

      <Form form={form} layout="vertical" initialValues={deliverer} onFinish={handleSave}>
        <Form.Item name="name" label="Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="calc_delivery_distance" label="Lieferradius-Formel">
          <Input.TextArea rows={2} />
        </Form.Item>
        <Form.Item name="calc_delivery_fee" label="Liefergebühr-Formel">
          <Input.TextArea rows={2} />
        </Form.Item>
        <Form.Item name="accepts_geo_location" label="Geo-Standort akzeptieren" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0 }}>
          <Button type="primary" htmlType="submit" loading={saving}>Speichern</Button>
        </Form.Item>
      </Form>
    </>
  );
}
